import { render, staticRenderFns } from "./FormBlackList.vue?vue&type=template&id=7fca5238&"
import script from "./FormBlackList.vue?vue&type=script&lang=js&"
export * from "./FormBlackList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports